import { Box } from 'grommet/es6/components/Box'
import { ThemeSelect } from 'app/components/ThemeSwitcher'
import { LanguageSelect } from 'app/components/LanguageSelect'
import { MobileScreenPrivacySelect } from 'app/components/MobileScreenPrivacySelect'
import { MobileUpdateGateSelect } from 'app/components/MobileUpdateGateSelect'

export const Settings = () => {
  return (
    <Box gap="small" style={{ flex: 1, justifyContent: 'space-between' }}>
      <Box>
        <LanguageSelect />
        <ThemeSelect />
        <MobileScreenPrivacySelect />
        <MobileUpdateGateSelect />
      </Box>
    </Box>
  )
}
